<template>
  <div>
    <app-cells><h1 class="title">Hotel reservations</h1></app-cells>
    <app-tabs :tabs="tabs" />
    <transition name="fade" mode="out-in">
      <router-view  />
    </transition>
  </div>
</template>

<script>
import AppTabs from '@/components/AppTabs'

export default {
  name: 'HotelsReservationsListLayout',
  components: { AppTabs },
  data() {
    return {
      tabs: [
        { name: 'reservation-hotels-list', label: 'Upcoming' },
        { name: 'reservation-hotels-list-in-house', label: 'In-House' },
        { name: 'reservation-hotels-list-archive', label: 'Archive' },
        { name: 'reservation-hotels-list-cancelled', label: 'Cancelled' },
      ],
    }
  },
}
</script>
